// extracted by mini-css-extract-plugin
module.exports = {"root":"MessagesList_root__JRdeF","header":"MessagesList_header__p5eMB","chat":"MessagesList_chat__C2xui"};